import { File, Image, CheckCircle2 } from "lucide-solid";
import { For, Show, type Component } from "solid-js";
import { formatBytes, type FileOffer } from "@kitae/transfer-protocol";
import { fileKind } from "../lib/files";

interface FileListProps {
  readonly files: readonly FileOffer[];
  readonly detailed: boolean;
  readonly progress?: Readonly<Record<string, number>>;
}

const FileList: Component<FileListProps> = (props) => (
  <ul class="file-list" aria-label="Fichiers du transfert">
    <For each={props.files}>{(file) => {
      const ratio = () => Math.min(100, Math.round(((props.progress?.[file.id] ?? 0) / Math.max(1, file.size)) * 100));
      return (
        <li class="file-row">
          <Show when={props.detailed}>
            <div class="file-preview">
              <Show when={file.thumbnail} fallback={file.type.startsWith("image/") ? <Image size={22} /> : <File size={22} />}>
                <img src={file.thumbnail} alt="" />
              </Show>
            </div>
          </Show>
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-2">
              <p class="truncate font-semibold text-[var(--ink)]">{file.name}</p>
              <Show when={ratio() === 100}><CheckCircle2 size={16} class="shrink-0 text-[var(--success)]" aria-label="Terminé" /></Show>
            </div>
            <p class="file-meta">
              {fileKind(file)} <span aria-hidden="true">·</span> {formatBytes(file.size)} <span aria-hidden="true">·</span>{" "}
              {new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium" }).format(file.lastModified)}
            </p>
            <Show when={(props.progress?.[file.id] ?? 0) > 0}>
              <div class="progress-track mt-2"><div class="progress-fill" style={{ width: `${ratio()}%` }} /></div>
            </Show>
          </div>
        </li>
      );
    }}</For>
  </ul>
);

export default FileList;
